var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/message.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-13422c21!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/message.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Message.vue
// module id = 666
// module chunks = 1